import { AnimatePresence, motion } from 'framer-motion';
import { useNavigationState } from '../context/navigation-context-provider';

export const NavigationBackdrop = () => {
  const { state } = useNavigationState();

  return (
    <AnimatePresence>
      {state.showBackdrop && (
        <motion.div
          data-testid="navigation_backdrop"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-[32] bg-primary-black/30"
        />
      )}
    </AnimatePresence>
  );
};
